import {
  IconCalendar,
  IconClock,
  IconDeviceDesktop,
  IconMapPin,
  IconWorld,
} from "@tabler/icons-react";

type TStatCardProps = {
  icon: React.ReactNode;
  label: string;
  value: string;
};

type TSessionDetailsStatsProps = {
  sessionStarted?: string;
  readingTime?: string;
  device?: string;
  location?: string;
  trafficType?: string | null;
  botSignature?: string | null;
};

const StatCard = ({ icon, label, value }: TStatCardProps) => {
  return (
    <div className="tw-space-y-3 tw-rounded-xl tw-bg-white tw-py-5 tw-shadow-2xs tw-outline tw-outline-1 tw-outline-blue/5">
      <div className="tw-flex tw-items-center tw-gap-2 tw-px-5 tw-font-sans tw-text-base tw-font-semibold tw-text-blue">
        {icon}
        {label}
      </div>
      <span className="tw-block tw-px-5 tw-py-0.5 tw-font-sans tw-text-sm tw-font-normal tw-text-blue">
        {value || "Not available"}
      </span>
    </div>
  );
};

export const SessionDetailsStats = ({
  sessionStarted,
  readingTime,
  device,
  location,
  trafficType,
  botSignature,
}: TSessionDetailsStatsProps) => {
  // The specific signature is the useful half for support - "Microsoft
  // SafeLinks opened this" closes a ticket that "Other bots" only opens.
  const traffic = botSignature
    ? `${trafficType} · ${botSignature}`
    : trafficType;

  return (
    <div className="tw-grid tw-grid-cols-5 tw-gap-4 -lg:tw-grid-cols-2 -md:tw-grid-cols-1">
      <StatCard
        icon={<IconCalendar className="tw-size-4 tw-text-blue" />}
        label="Session started"
        value={sessionStarted || "Not available"}
      />
      <StatCard
        icon={<IconClock className="tw-size-4 tw-text-blue" />}
        label="Reading time"
        value={readingTime || "----"}
      />
      <StatCard
        icon={<IconDeviceDesktop className="tw-size-4 tw-text-blue" />}
        label="Device"
        value={device || "Not available"}
      />
      <StatCard
        icon={<IconWorld className="tw-size-4 tw-text-blue" />}
        label="Traffic type"
        value={traffic || "Not available"}
      />
      <StatCard
        icon={<IconMapPin className="tw-size-4 tw-text-blue" />}
        label="Location"
        value={location || "Not available"}
      />
    </div>
  );
};
